import React, { memo, useEffect } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay } from "swiper/modules"
import AOS from "aos"
import "aos/dist/aos.css"
import OptimizedImage from "../../ImageShow/OptimizedImage"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import * as style from "./cliensPartners.module.css"

const CliensPartners = ({
  CustomClass,
  homeWorkContent,
  homeWorkLogoList,
  homeWorkShowSection,
  homeWorkSubTitle,
  homeWorkTitle,
}) => {
  const sliderTop = homeWorkLogoList?.slice(
    0,
    Math.ceil(homeWorkLogoList?.length / 2)
  )
  const sliderBottom = homeWorkLogoList?.slice(
    Math.ceil(homeWorkLogoList?.length / 2)
  )

  //
  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  return (
    <>
      {homeWorkShowSection === "yes" && (
        <section
          className={`${CustomClass}`}
          data-aos="fade-up"
          data-aos-delay="50"
        >
          <div className="container">
            <div className={style.client_partner_wrap}>
              <div className={style.client_partner_Leftbox}>
                <SectionsTitle
                  title={homeWorkTitle}
                  SubTitle={homeWorkSubTitle}
                  Content={homeWorkContent}
                  styleCss={{ display: "none" }}
                />
              </div>
              <div
                className={`swiper-slider client-logo-slider ${style.client_logo_rightBox}`}
              >
                <Swiper
                  autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                  }}
                  speed={7000}
                  modules={[Autoplay]}
                  className="infraSlider"
                  loopAdditionalSlides={0}
                  loop={true}
                  slidesPerView="auto"
                  allowTouchMove={false}
                  spaceBetween={30}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                      spaceBetween: 15,
                    },
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 15,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 15,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 40,
                    },
                  }}
                >
                  <div className="swiper-wrapper">
                    {sliderTop?.map((item, index) => {
                      return (
                        <SwiperSlide key={`${item + index}`}>
                          <div className={style.slider_box}>
                            <div className={style.client_logo_wrap}>
                              <OptimizedImage
                                imageData={
                                  item?.homeWorkListLogoImage?.mediaItemUrl
                                    ? item?.homeWorkListLogoImage?.mediaItemUrl
                                    : "/images/placeholder-image.jpg"
                                }
                                alt={item?.homeWorkListLogoImage?.altText}
                              />
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    })}
                  </div>
                </Swiper>

                {/* bottm slider */}
                <Swiper
                  autoplay={{
                    delay: 0,
                    reverseDirection: true,
                  }}
                  speed={7000}
                  modules={[Autoplay]}
                  className="infraSlider"
                  loopAdditionalSlides={0}
                  loop={true}
                  slidesPerView="auto"
                  allowTouchMove={false}
                  spaceBetween={30}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                      spaceBetween: 15,
                    },
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 15,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 15,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 40,
                    },
                  }}
                >
                  <div className="swiper-wrapper">
                    {Array.isArray(sliderBottom) &&
                      sliderBottom?.map((item, index) => {
                        return (
                          <SwiperSlide key={`${item}_${index}`}>
                            <div className={style.slider_box}>
                              <div className={style.client_logo_wrap}>
                                <OptimizedImage
                                  imageData={
                                    item?.homeWorkListLogoImage?.mediaItemUrl
                                      ? item?.homeWorkListLogoImage
                                        ?.mediaItemUrl
                                      : "/images/placeholder-image.jpg"
                                  }
                                  alt={item?.homeWorkListLogoImage?.altText}
                                />
                              </div>
                            </div>
                          </SwiperSlide>
                        )
                      })}
                  </div>
                </Swiper>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(CliensPartners)
